import React from 'react';
import styled from '@emotion/styled';
import { Badge, Table } from 'antd';
import { useTranslation } from 'react-i18next';
import moment from 'moment-timezone';
import { USER_PROFILE } from '../../../constants/define/translation';
import { CommonColumn } from '../shared-column';
import { ActionsColumn } from './columns';
import { FORMAT_DATETIME_US } from '../../../constants/common';

export const CDMTable = (prop: any) => {
  const { userProfile } = prop;
  const { userCDM } = userProfile;
  const { t } = useTranslation(USER_PROFILE);
  const { Column } = Table;

  const formatDate = (datetime: string) => {
    if (!datetime) return '';
    return moment(datetime).format(FORMAT_DATETIME_US);
  };

  const records: any = [
    {
      description: 'createdAt',
      value: formatDate(userProfile?.createdAt),
    },
    {
      description: 'emailVerified',
      value: (
        <Badge status={userCDM?.emailVerified ? 'success' : 'error'} text={userCDM?.emailVerified ? 'true' : 'false'} />
      ),
    },
    {
      description: 'tmAccessCode',
      value: (
        <Badge status={userCDM?.tmAccessCode ? 'success' : 'error'} text={userCDM?.tmAccessCode ? 'true' : 'false'} />
      ),
    },
    {
      description: 'cdmUID',
      value: userCDM?.id,
      action: 'COPY',
    },
    {
      description: 'auth0ID',
      value: userCDM?.tmUserIds?.auth0Id,
      action: 'COPY',
    },
  ];
  const loading = false;

  return (
    <>
      <StyledTable dataSource={records} loading={loading} rowKey="id" pagination={false}>
        <Column
          title={t('table.title.description')}
          width={200}
          dataIndex="description"
          key="description"
          render={value => <CommonColumn value={value} />}
          align="center"
        />
        <Column
          title={t('table.title.value')}
          width={200}
          dataIndex="value"
          key="value"
          render={value => <CommonColumn value={value} />}
          align="center"
          className="fcmToken"
          ellipsis
        />
        <Column
          title={t('table.title.action')}
          width={200}
          dataIndex="action"
          key="action"
          render={(value, record) => <ActionsColumn record={record} />}
          align="center"
        />
      </StyledTable>
    </>
  );
};

const StyledTable = styled(Table)`
  .fcmToken > div {
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .tableGolf {
    padding: 0 1rem;
  }
`;
